import React, { ReactElement } from 'react';

type FullPoints = {
  table: number;
  matchStringLong: string;
  timePerMoveStringL: string;
};

export const TablePointsInfo = (props: { fullPoints: FullPoints }) => {
  function renderPointItem(matchStringLong: string) {
    return matchStringLong.split('\n').map(
      (line: string, index: number): ReactElement => {
        if (line.startsWith('match_')) {
          const matchPoints = line.slice(6);
          return (
            <div className="table-list__points-dialog-text" key={`${index}_${line}`}>{`Match: ${matchPoints}`}</div>
          );
        } else {
          return (
            <div className="table-list__points-dialog-text" key={`${index}_${line}`}>
              {line}
            </div>
          );
        }
      }
    );
  }

  return (
    <div className="table-list__points-dialog">
      {/*<span className="table-list__points-dialog-title">{`Table ${props.fullPoints.table}`}</span>*/}
      {renderPointItem(props.fullPoints.matchStringLong)}
      <span className="table-list__points-dialog-text">{props.fullPoints.timePerMoveStringL}</span>
    </div>
  );
};
